export default function exportProductCompareDataToXLS() {
    return {
        'PartNumber': 'PartNumber',
        'CustomerPartNumbers':'Customer Part Number',
        'Quantity': 'Quantity',
        'Min': 'QtyMin',
        'Mult': 'QtyMult',
        'DataSheet': 'DataSheet',
        'Manufacturer': 'Manufacturer',
        'Availability': 'Availability',
        'Currency':'Currency',
        "PRICE_1": "PRICE_1",
        "Tier 1 - Quantity": "Tier 1 - Quantity",
        "PRICE_2": "PRICE_2",
        "Tier 2 - Quantity": "Tier 2 - Quantity",
        "PRICE_3": "PRICE_3",
        "Tier 3 - Quantity": "Tier 3 - Quantity",
        "PRICE_4": "PRICE_4",
        "Tier 4 - Quantity": "Tier 4 - Quantity",
        "PRICE_5": "PRICE_5",
        "Tier 5 - Quantity": "Tier 5 - Quantity",
        "PRICE_6": "PRICE_6",
        "Tier 6 - Quantity": "Tier 6 - Quantity",
        "PRICE_7": "PRICE_7",
        "Tier 7 - Quantity": "Tier 7 - Quantity",
        "PRICE_8": "PRICE_8",
        "Tier 8 - Quantity": "Tier 8 - Quantity",
        "PRICE_9": "PRICE_9",
        "Tier 9 - Quantity": "Tier 9 - Quantity",
        "PRICE_10": "PRICE_10",
        "Tier 10 - Quantity": "Tier 10 - Quantity"
    }
};